<template>
  <div class="exam-register-page">
    <Mytitle />
    <div class="page-header">
      <h3>考试报名</h3>
      <div class="meta">考试ID：{{ examId || '未知' }}</div>
      <div class="meta" v-if="examDetail">
        报名费：{{ formatFee(examDetail.fee) }}
      </div>
      <button class="btn-back" @click="goBack">返回我的报名</button>
    </div>

    <div class="content">
      <ExamRegistrationForm :exam="examDetail ? examDetail : { id: examId }" :layout="'sheet'"
        @submitted="handleSubmitted" />
    </div>
  </div>
</template>

<script>
import Mytitle from "../assets/title.vue"
import ExamRegistrationForm from "./ExamRegistrationForm.vue"
import { getExam } from "../api/exams"

export default {
  name: 'ExamRegisterPage',
  components: { Mytitle, ExamRegistrationForm },
  props: {
    examId: { type: [String, Number], default: '' }
  },
  data() {
    return {
      examDetail: null,
      loading: false,
      error: ''
    }
  },
  async mounted() {
    // 检查登录状态
    const token = localStorage.getItem('user_access_token') || '';
    if (!token) {
      this.error = '请先登录';
      setTimeout(() => {
        window.location.hash = 'login';
      }, 1500);
      return;
    }
    
    await this.fetchExamDetail()
    await this.guardAlreadyApplied()
  },
    methods: {
    goBack() {
      try {
        const arr = JSON.parse(localStorage.getItem('app_history') || '[]')
        const prev = arr.pop()
        localStorage.setItem('app_history', JSON.stringify(arr))
        if (prev && prev.hash) {
          if (prev.hash === '#home') {
            if (prev.subNav === '报名中') {
              localStorage.setItem('redirect_to_active_exams', '1')
            } else if (prev.nav === '我的报名') {
              localStorage.setItem('redirect_to_my_registration', '1')
            }
          }
          window.location.hash = prev.hash.replace(/^#?/, '#')
          return
        }
      } catch (e) { /* noop */ }
      window.location.hash = 'home'
    },
    async fetchExamDetail() {
      this.error = ''
      this.loading = true
      try {
        if (!this.examId) {
          this.error = '缺少考试ID，无法加载考试详情';
          this.loading = false
          return
        }
        
        // 验证examId格式
        if (!/^\d+$/.test(String(this.examId))) {
          this.error = '无效的考试ID格式';
          this.loading = false
          return
        }
        
        const d = await getExam(this.examId)
        if (!d) {
          this.error = '考试不存在或已被删除';
          this.examDetail = null
        } else {
          this.examDetail = d
        }
      } catch (e) {
        console.error(e)
        const status = e?.response?.status
        if (status === 404) {
          this.error = '考试不存在或已被删除'
        } else if (status === 401) {
          this.error = '请先登录'
          setTimeout(() => window.location.hash = 'login', 1500)
        } else {
          this.error = '考试详情加载失败，请稍后重试'
        }
        this.examDetail = null
      } finally {
        this.loading = false
      }
    },
    async guardAlreadyApplied() {
      try {
        const token = localStorage.getItem('user_access_token') || ''
        if (!token || !this.examId) return
        const res = await fetch('/api/exam/applications/my/', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        if (res && res.ok) {
          const list = await res.json()
          const found = Array.isArray(list) ? list.find(x => String(x?.exam?.id || x?.exam_id || '') === String(this.examId)) : null
          if (found) {
            // 无论报名状态如何，都允许进入报名页查看信息
            // 移除直接跳转到准考证页面的逻辑，让用户自己选择操作
            console.log('用户已报名该考试，状态：', found?.status || found?.audit_status || '')
          }
        }
      } catch (e) {
        // 静默失败，不影响继续报名流程
        console.warn('已报名检测失败', e)
      }
    },
    handleSubmitted() {
      try {
        localStorage.setItem('applications_need_refresh', '1')
        localStorage.setItem('redirect_to_my_registration', '1')
        window.dispatchEvent(new Event('applications:updated'))
      } catch (e) { /* noop */ }
      setTimeout(() => this.goBack(), 1500)
    },
    formatFee(value) {
      const num = Number(value ?? 0)
      if (Number.isNaN(num)) return '¥0.00'
      return '¥' + num.toFixed(2)
    }
  }
}
</script>

<style scoped>
.exam-register-page {
  padding: 16px;
  max-width: 980px;
  margin: 0 auto; /* 页面居中 */
}

.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.page-header h3 {
  color: #0066cc;
  margin: 0;
}

.meta {
  color: #888;
}

.btn-back {
  margin-left: auto;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.content {
  background: #fff;
  border: 1px solid #ddd; /* 添加边框 */
  border-radius: 8px;
  padding: 20px; /* 内边距稍微加大 */
  margin-top: 12px; /* 与页头留间距 */
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}
</style>
